import { useContext, useCallback } from 'react';

import { formatListData, AjaxContext } from 'commons-ui';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getPartnerCouponData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const response = await postData({
				endpoint: '/marketing/dashboard/partnerCoupon/getCoupons',
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isPartnerCoupon: true
				},
				queryParams: {
					appName: app.appName
				}
			});
			const listData = formatListData(response?.data?.coupons);
			return { rowCount: response?.data?.count, data: listData };
		},
		[]
	);

	const requestCreateCoupon = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/partnerCoupon/createCoupon',
			body: { ...data, isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateCoupon = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/partnerCoupon/updateCoupon',
			body: { ...data, isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdatePartnerCoupon = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/partnerCoupon/updatePartnerCoupons',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestCreatePartnerCoupon = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/partnerCoupon/createPartnerCoupons',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const showBulkCouponData = useCallback(
		(cid: any) =>
			async ({ app, pageDetails, sortDetails }: { app: any; pageDetails: any; sortDetails: any }) => {
				const response = await postData({
					endpoint: '/marketing/dashboard/partnerCoupon/getPartnerCoupons',
					body: {
						page: pageDetails,
						sortInfoArray: sortDetails,
						cid
					},
					queryParams: {
						appName: app.appName
					}
				});
				const listData = formatListData(response?.data?.partnerCsvLinks);
				return { rowCount: response?.data?.count, data: listData };
			},
		[]
	);

	return {
		getPartnerCouponData,
		requestUpdateCoupon,
		requestCreateCoupon,
		requestUpdatePartnerCoupon,
		requestCreatePartnerCoupon,
		showBulkCouponData
	};
};

export default useService;
